// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 936) return "static/chunks/common-33575219-a23cbeeb317d56a9.js";
	if (chunkId === 3602) return "static/chunks/common-2945abbf-2f2a0af3164dd851.js";
	if (chunkId === 1221) return "static/chunks/common-91059ad5-9723ed0eeb90ef01.js";
	if (chunkId === 4937) return "static/chunks/common-97e3b44b-ef826a30d1ed6bf8.js";
	if (chunkId === 195) return "static/chunks/195-a1ecd9e598b551ee.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"135":"4323bb70605b1061","426":"36980e7b3922c511","682":"e49e2ef35850e49f","2516":"3b476a828c1ac4c5","2969":"e38bdc9eaee3ba89","6650":"beb2773236fe66d8","7715":"aef7ca6c22beb4e0","8045":"3820af5e3fea6102"}[chunkId] + ".js";
};